import React, { useEffect, useState } from "react";
import { colorConstant } from "../../../../../styles/colorConstant/colorConstant";
import { Box, Modal } from "@mui/material";
import "./TableDetailsModal.css";
import { PosCustomButton } from "../../../../../customComponents/PosCustomButton/PosCustomButton";
import { fetchTableBookingStatus, manualTableCancellation } from "../../../../../config/Services";
import { useSnackbar } from "../../../product/hooks/SnackbarProvider";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 500,
  width: "auto",
  height: "auto",
  bgcolor: `${colorConstant.surfaceWhite}`,
  paddingTop: "25px",
  paddingLeft: "16px",
  paddingRight: "16px",
  paddingBottom: "16px",
  borderRadius: "12px",
  overflow: "scroll",
};

const TableDetailsModal = ({
  tableDetailsModalOpen,
  setTableDetailsModalOpen,
  selectedTableMapId,
  setCanceledTable,
}) => {
  const [tableBookingStatus, setTableBookingStatus] = useState([]);
  const [statusLoader, setStatusLoader] = useState(false);
  const [tableReleaseLoader, setTableReleaseLoader] = useState(false);
  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");
  const showSnackbar = useSnackbar();
  const navigate = useNavigate();

  //Handling release table
  const handleReleaseTable = () => {
    setTableReleaseLoader(true);
    //Filtering table to release
    const tableToRelease = tableBookingStatus?.filter(
      (booking) => booking?.mapId === selectedTableMapId
    );
    //API to manually releasing table
    manualTableCancellation(tableToRelease[0]?.slotId)
      .then((res) => {
        //Handling success error
        if (
          res?.data?.es > 0 ||
          res?.data?.data?.es > 0 ||
          res?.data?.status === "ERROR" ||
          res?.data?.data?.status === "ERROR"
        ) {
          showSnackbar(res?.data?.message || "Unable to cancel table reservation", "error");
          setTableReleaseLoader(false);
          return;
        }
        showSnackbar(res?.data?.message || "Table successfully canceled", "success");
        setCanceledTable(res?.data?.data);
        setTableReleaseLoader(false);
        handleClose();
      })
      .catch((err) => {
        showSnackbar(err?.message || err || "Unable to cancel table reservation", "error");
        setTableReleaseLoader(false);
      });
  };

  const handleGoToCart = () => {
    navigate("/restaurant/cart");
  }

  //Handling modal close
  const handleClose = () => {
    setTableDetailsModalOpen(false);
  };

  useEffect(() => {
    if (tableDetailsModalOpen) {
      if (tableBookingStatus?.length > 0) {
        return;
      }
      setStatusLoader(true);
      fetchTableBookingStatus(orgId, locId, "CHECKED_IN")
        .then((res) => {
          //Handling success error
          if (
            res?.data?.es > 0 ||
            res?.data?.data?.es > 0 ||
            res?.data?.status === "ERROR" ||
            res?.data?.data?.status === "ERROR"
          ) {
            showSnackbar(res?.data?.message || "Unable to fetch booking status", "error");
            setStatusLoader(false);
            return;
          }
          setTableBookingStatus(res?.data?.reservations);
          setStatusLoader(false);
        })
        .catch((err) => {
          showSnackbar(err?.message || err || "Unable to fetch booking status", "error");
        });
    }
  }, [tableDetailsModalOpen]);

  return (
    <div>
      <Modal open={tableDetailsModalOpen} onClose={handleClose}>
        <Box sx={style}>
          <div className="tableModalContainer">
            <div className="tableModalImageContainer">
              <img
                src="https://storage.googleapis.com/twinleaves_bucket/table-modal.png"
                height={"100%"}
                width={"100%"}
                alt="table"
              />
            </div>
            <p className="tableModalTableName">Table: T1</p>
            <div className="legend-item">
              <span className="legend-dot occupied"></span>
              <span className="legend-text">Occupied</span>
            </div>
            <div className="tableModalActionButton">
              <PosCustomButton
                title="Release Table"
                variant="black-s"
                width="100%"
                p="10px 12px"
                radius="4px"
                onClickFunction={handleReleaseTable}
                loading={statusLoader || tableReleaseLoader}
                disabled={tableBookingStatus.length === 0}
              />
              <PosCustomButton
                title="Transfer Table"
                variant="blue-s"
                width="100%"
                p="10px 12px"
                radius="4px"
                transparent={true}
                disabled={true}
              />
              <PosCustomButton
                title="Go to cart"
                variant="blue-d"
                width="100%"
                p="10px 12px"
                radius="4px"
                border={true}
                onClickFunction={handleGoToCart}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default TableDetailsModal;
